(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gms-header"]) return;
  try {
    
if (!customElements.get('gms-scroll-header')) {
  customElements.define('gms-scroll-header', class extends HTMLElement {
    connectedCallback() {
      this.header = this.querySelector('.gms-header');
      this.nav = this.querySelector('.gms-nav');
      this.menu = this.querySelector('.gms-mobile-menu');
      if (!this.header || !this.nav) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.lastY = this.scrollPosition();
      this.travel = 0;
      this.pinned = false;
      this.measure();
      this.update();
      window.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }, { ...options, passive: true });
      window.addEventListener('resize', () => { this.measure(); this.update(); }, options);
      window.addEventListener('pageshow', () => {
        this.measure();
        this.lastY = this.scrollPosition();
        this.travel = 0;
        this.update();
      }, options);
      this.nav.addEventListener('focusin', () => this.show(), options);
      this.menu?.addEventListener('toggle', () => {
        if (this.menu.open) this.show();
        this.travel = 0;
      }, options);
      this.nav.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.menu?.open) {
          this.menu.open = false;
          this.menu.querySelector('summary').focus();
        }
      }, options);
      document.addEventListener('shopify:section:select', event => {
        if (!event.target.contains(this)) return;
        this.selected = true;
        this.show();
      }, options);
      document.addEventListener('shopify:section:deselect', event => {
        if (event.target.contains(this)) this.selected = false;
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.animationFrame);
    }
    scrollPosition() {
      return Math.max(0, Math.min(window.scrollY, document.documentElement.scrollHeight - window.innerHeight));
    }
    measure() {
      const configuredInset = parseFloat(getComputedStyle(this.header).getPropertyValue('--gms-nav-inset'));
      const inset = Number.isFinite(configuredInset) ? configuredInset : 14;
      const announcement = this.querySelector('.gms-announcement').offsetHeight;
      const origin = this.getBoundingClientRect().top + window.scrollY;
      this.restoreAt = origin + announcement;
      this.pinAt = this.restoreAt + inset + this.nav.offsetHeight + 24;
      this.naturalHeight = this.header.classList.contains('gms-header--overlay') ? announcement : announcement + this.nav.offsetHeight + inset * 2;
      if (this.pinned) this.header.style.minHeight = `${this.naturalHeight}px`;
    }
    show() {
      this.header.classList.remove('gms-header--hidden');
    }
    update() {
      const y = this.scrollPosition();
      const delta = y - this.lastY;
      this.lastY = y;
      if (y <= this.restoreAt) {
        this.pinned = false;
        this.travel = 0;
        cancelAnimationFrame(this.animationFrame);
        this.header.classList.remove('gms-header--pinned', 'gms-header--hidden', 'gms-header--animate');
        this.header.style.removeProperty('min-height');
        return;
      }
      const keepVisible = this.menu?.open || this.nav.querySelector(':focus-visible') || this.selected;
      if (!this.pinned && y > this.pinAt) {
        this.pinned = true;
        this.header.style.minHeight = `${this.naturalHeight}px`;
        this.header.classList.add('gms-header--pinned');
        this.header.classList.toggle('gms-header--hidden', !keepVisible && delta >= 0);
        this.nav.getBoundingClientRect();
        this.animationFrame = requestAnimationFrame(() => this.header.classList.add('gms-header--animate'));
        this.travel = 0;
      }
      if (!this.pinned) return;
      if (keepVisible) {
        this.show();
        this.travel = 0;
        return;
      }
      if (delta === 0) return;
      this.travel = Math.sign(delta) === Math.sign(this.travel) ? this.travel + delta : delta;
      if (this.travel <= -8) this.show();
      if (this.travel >= 12) this.header.classList.add('gms-header--hidden');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
